export const clearOfferName = (name: string) => {
    const regex = /-?\setap|-?\s[ivx]{1,3}[a-z]? etap|\sbud\.? \d+|-?\sbudynek ([a-z]?|\d+)|\s(?!ii$)[ivx]{1,3}[a-z]{1}$/g;
    const findPhrase = name.toLowerCase().match(regex)?.[0];

    if (findPhrase) {
        const indexOfPhrase = name.toLowerCase().indexOf(findPhrase);
        return name.slice(0, indexOfPhrase).trim();
    }

    return name;
};
